import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css';
//import "bootstrap/dist/css/bootstrap.min.css"
import VueResource from 'vue-resource';
//import store from './store/store';
import BootstrapVue from 'bootstrap-vue'

//Retrive data for Clode Firestore
import VueFire from 'vuefire'
import firebase from 'firebase'
import 'firebase/firestore'
Vue.use(VueFire)
//End.

//05-Dec-2018, For storage in Firebase
import 'firebase/storage'

Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.use(Vuex);


export const store = new Vuex.Store({
  state: {
    isAdded:0,
    channel: '',
    cartQty:0,
    cartItemList:[],
    cartTotal:0,
    cartItemDescr:'',
    userInfo: { //17-dec
      isLoggedIn: false,
      isSignedUp: false,
      hasSearched: false,
      name: '',
      productTitleSearched: ''
    },
  },
  mutations: {
    change(state, channel) {
      state.channel = channel
    }, //17-Dec
    isUserLoggedIn: (state, isUserLoggedIn) => {
      state.userInfo.isLoggedIn = isUserLoggedIn;
    },
    isUserSignedUp: (state, isSignedUp) => {
      state.userInfo.isSignedUp = isSignedUp;
    },
    setUserName: (state, name) => {
      state.userInfo.name = name;
    },
    setCartItemDescr:(state, cartItemDescr) => {
      state.cartItemDescr = cartItemDescr;
    },
    ADD_ITEM: (state, order) => {
      this.isAdded = 0
      state.cartQty = state.cartQty + 1
      if (state.cartItemList.length == 0){
        state.cartItemList.push({...order});  //push value one by one to array
        this.isAdded = 1
        //Calcualte the Cart Total
        state.cartTotal += (order.item.price * order.quantity)
      } else {
        //Listing order items in the list
        state.cartItemList.forEach((service, index) => {
          
          if (service.item.name == order.item.name)
          {
            service.quantity += order.quantity
            this.isAdded = 1
          } 
          });

          //No record is found, then add one.
          if (this.isAdded == 0){
            state.cartItemList.push({...order});  //push value one by one to array
            this.isAdded = 1
          }

          //Calcualte the Cart Total
          state.cartTotal += (order.item.price * order.quantity)
        }      
    },
    REMOVE_ITEM: (state, order) => {
      const record = state.cartItemList.find(element => element.item.name == order.item.name);
      state.cartQty = state.cartQty - order.quantity;
      state.cartTotal -= (order.item.price) * order.quantity;
      state.cartItemList.splice(state.cartItemList.indexOf(record), 1);
    },
    GET_ITEM_DESCR: (state) => {
      //Setup Cart Items Descr for submit mail.
      state.cartItemDescr = ''
      state.cartItemList.forEach((service, index) => {
         state.cartItemDescr += service.item.name + ' x ' + service.quantity + '.\n'
      });
      state.cartItemDescr += '\nTotal $ ' + state.cartTotal.toFixed(2) + '\n'

    }
  },
  actions: {
    ADD_ITEM: (context, order) => {
      context.commit("ADD_ITEM",order);
    },
    REMOVE_ITEM: (context, order) => {
      context.commit("REMOVE_ITEM",order);
    },
    GET_ITEM_DESCR: (context) => {
      context.commit("GET_ITEM_DESCR");
    }
  },
  getters: {
    channel: state => state.channel,
    cartQty: state => state.cartQty, //cartItemList.length,
    productsAdded: state => { //18-dec
      return state.products.filter(el => {
        return el.isAddedToCart;
      });
    },
    isUserLoggedIn: state => { //17-dec
      return state.userInfo.isLoggedIn;
    },
    isUserSignedUp: state => {
      return state.userInfo.isSignedUp;
    },
    getUserName: state => {
      return state.userInfo.name;
    },
    cartItemList: state => {
      return state.cartItemList
    },
    cartTotal: state => {
      return state.cartTotal.toFixed(2)
    },
    cartItemDescr: state => {
      return state.cartItemDescr
    }
  }
});

Vue.config.productionTip = false

let app;
 // Initialize Firebase
 var config = {
  apiKey: "AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk",
  authDomain: "vue-authenication.firebaseapp.com",
  databaseURL: "https://vue-authenication.firebaseio.com",
  projectId: "vue-authenication",
  storageBucket: "vue-authenication.appspot.com",
  messagingSenderId: "510038787119"
};
firebase.initializeApp(config);

//For Firestore
export const db = firebase.firestore();

//5-Dec-2108
export const storage = firebase.storage();

firebase.auth().onAuthStateChanged(function(user){
  if(!app){
    app = new Vue({
      el: '#app',
      store,
      template: '<App/>',
      components: { App },
      router
    })
  }
});


Vue.config.productionTip = false
/*using mount is same as using element
new Vue({
  render: h => h(App)
}).$mount('#app')
*/

/*
new Vue({
  el: '#app',
  router,
  components: { App },
	template: '<App/>'
})
*/


// WEBPACK FOOTER //
// ./src/main.js